// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-18T15:10:16+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190487
//    Project:        510
//    Environment:    3832 - master
//    MD5:            3768e8c6c369e1d67319ee4696369466
//    Signature:      eyJpdiI6IlA2VUJVYjNwXC8xWUZZQkJMeE5FZFNRPT0iLCJ2YWx1ZSI6IlA3WVUwNTdFcG03WUtQOFFac2VFZVNXZVF1SU5kSzRYaDlnSkN1QlVqNFNLbzJiUWNRM1hPVWFnMFg1VWxrcks1RzBYMG10RUFwTHhQVk5aQ1p1ODZWXC9DNzcxelhMaWFuTVhMWlV0Um9uRzI3aVU2UXdSY1pLTHlBQ1RMd01Zb3JJdTZqZGZ4WGlwYTR5NEtcL0RCcCsrYlpra3pOXC9WbmlwU1BwR2VVektGUzVGeVBJaXNVMFMrWUY1cEY5NVRySFJUTmhGeFpjQzZiOTVmbmJia2JKN2ZSMGdodHNGUTE4K3JrYmxWSCtkTWVyM0pzUlA1UXBtMUM5T0FnUzVsUlpiMmpGTzBqVng1STQyOENUcVR6SUhUc0RaRnBaMUJcL21wcmJpOEh6QzJaSHZDK25KdnRGam9sMkp6WFNYdGFsUDRSVFwvTVlleUtuM3oxcFJ5MUJzcEMrTHl0VkxZQVZJcG1iVUJPdGNMVGlhNEk5a2VUYkZRSG9XeFZEMUM5TUp3NG9mWEJ5UVdlVWVFanl3RXpkV0dtenlPQ3JwcTFPVU4yTXVpZStGalIrOD0iLCJtYWMiOiJlODc3MzcxMTUzNTZhNDNjNDAwMThkYWE1OWY1YzRhMjZhMjM0NTE3ZjIxYTBiMTYzNDNhZmJhY2E0YWQxZTJkIn0=
if (!window.__mpSwatchMoreInit) {
  window.__mpSwatchMoreInit = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-swatch-toggle]');
    if (!btn) return;

    const targetId = btn.getAttribute('aria-controls');
    const target = targetId ? document.getElementById(targetId) : null;

    if (!target) return;

    const expanded = target.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });
}
